var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeatPump = function SvgHeatPump(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m5.917-7a6 6 0 0 1-1.026 2.477L14.414 13zm-2.44 3.89L13 14.415v3.503a6 6 0 0 0 2.476-1.026M11 17.918v-3.503l-2.477 2.477A6 6 0 0 0 11 17.917m-3.89-2.44L9.585 13H6.083a6 6 0 0 0 1.026 2.476M17.916 11h-3.503l2.477-2.477A6 6 0 0 1 17.917 11m-2.44-3.89A6 6 0 0 0 13 6.082v3.503zM11 6.082a6 6 0 0 0-2.477 1.026L11 9.586zm-3.89 2.44A6 6 0 0 0 6.082 11h3.503zM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 1a4 4 0 0 0-4 4v14a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4V5a4 4 0 0 0-4-4zm0 2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })));
};
export default SvgHeatPump;